import { render } from "./AppDescriptionItem.vue?vue&type=template&id=530bd198&scoped=true"
import script from "./AppDescriptionItem.vue?vue&type=script&lang=js"
export * from "./AppDescriptionItem.vue?vue&type=script&lang=js"

import "./AppDescriptionItem.vue?vue&type=style&index=0&id=530bd198&lang=scss&scoped=true"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-530bd198"]])

export default __exports__